package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class CommentEntityType(private val literal: String) : IEnumType {
	Content("Content"),
	Meridian("Meridian"),
	Acupoint("Acupoint"),
	Medicine("Medicine"),
	Prescription("Prescription"),
	SignSymptom("SignSymptom");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "comment_entity_type"}
	override fun getLiteral(): String {return literal}
}
